import * as types from 'store/modules/hrms75e/mutation-types'
import hrms75e from 'api/hrms75e'
import swal from 'sweetalert'
import hrms75eLabels from 'assets/labels/hrms75e'
import { hrms75eMaxRowspan, hrms75eColumns } from 'assets/columns/hrms75e'
import configLabel from 'src/../config/label'
import axios from 'axios'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hrms75eLabels,
    maxRowspan: hrms75eMaxRowspan,
    columns: hrms75eColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail: {
      cours: {
        detail: {},
        table: {
          total: 0,
          rows: []
        }
      },
      tab1: {
        total: 0,
        rows: []
      },
      tab2: {
        detail: {},
        table: {
          total: 0,
          rows: []
        }
      },
      tab3: {
        detail: {},
        table: {
          total: 0,
          rows: []
        }
      },
      tab4: {
        detail: {},
        table: {
          total: 0,
          rows: []
        }
      },
      tab5: {
        detail: {},
        table: {
          total: 0,
          rows: []
        }
      }
    },
    indexSelected: {},
    popupCours: {},
    detailTab2Popup: {
      total: 0,
      rows: []
    },
    detailTab4Popup: {
      total: 0,
      rows: []
    },
    dropdowns: {
      codcours: {
        en: {},
        th: {}
      }
    }
  },
  getters: {
    [types.GET_HRMS75E_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRMS75E_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRMS75E_MAX_ROWSPAN] (state) {
      return state.maxRowspan
    },
    [types.GET_HRMS75E_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRMS75E_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRMS75E_INDEX] (state) {
      return state.index
    },
    [types.GET_HRMS75E_SEARCH_PARAMS_INDEX] (state) {
      return state.searchParamsIndex
    },
    [types.GET_HRMS75E_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRMS75E_DETAIL] (state) {
      return state.detail
    },
    [types.GET_HRMS75E_DETAIL_TAB2_POPUP] (state) {
      return state.detailTab2Popup
    },
    [types.GET_HRMS75E_DETAIL_TAB4_POPUP] (state) {
      return state.detailTab4Popup
    },
    [types.GET_HRMS75E_DETAIL_TAB3_SELECTED] (state) {
      return state.detailTab3Selected
    },
    [types.GET_HRMS75E_COURS_POPUP] (state) {
      return state.popupCours
    }
  },
  mutations: {
    [types.SET_HRMS75E_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRMS75E_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRMS75E_COLUMNS] (state, { labels, dropdowns }) {
      for (var keyLang of configLabel.allLang) {
        let dropdownSets = [
          { key: 'codcours', value: dropdowns.codcours[keyLang] }
        ]
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].detailCours = configLabel.replaceLabelToColumns(state.columns[keyLang].detailCours, labels[keyLang], dropdownSets)
        state.columns[keyLang].detailTab1 = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab1, labels[keyLang])
        state.columns[keyLang].detailTab2 = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab2, labels[keyLang])
        state.columns[keyLang].detailTab2Popup = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab2Popup, labels[keyLang])
        state.columns[keyLang].detailTab3 = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab3, labels[keyLang])
        state.columns[keyLang].detailTab4 = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab4, labels[keyLang])
        state.columns[keyLang].detailTab4Popup = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab4Popup, labels[keyLang])
        state.columns[keyLang].detailTab5 = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab5, labels[keyLang])
      }
    },
    [types.SET_HRMS75E_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRMS75E_INDEX] (state, index) {
      state.index = index
    },
    [types.SET_HRMS75E_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRMS75E_DETAIL] (state, detail) {
      state.detail = detail
    },
    [types.SET_HRMS75E_DETAIL_TAB2_POPUP] (state, detailTab2Popup) {
      state.detailTab2Popup = detailTab2Popup
    },
    [types.SET_HRMS75E_DETAIL_TAB4_POPUP] (state, detailTab4Popup) {
      state.detailTab4Popup = detailTab4Popup
    },
    [types.SET_HRMS75E_DETAIL_TAB3_SELECTED] (state, detailTab3Selected) {
      state.detailTab3Selected = detailTab3Selected
    },
    [types.SET_HRMS75E_DROPDOWNS] (state, dropdowns) {
      state.dropdowns = dropdowns
    },
    [types.SET_HRMS75E_COURS_POPUP] (state, popupCours) {
      state.popupCours = popupCours
    },
    // [types.SET_HRMS75E_ADD_CODCOURS] (state, dataRowsCodcours) {
    //   for (let index = 0; index < dataRowsCodcours.length; index++) {
    //     let dataRow = dataRowsCodcours[index]
    //     dataRow['staappr'] = 'P'
    //     let rowIndex = state.detail.cours.table.rows.map(function (stateDataRow) {
    //       return stateDataRow.codcours
    //     }).indexOf(dataRow.codcours)
    //     if (rowIndex <= -1) {
    //       state.detail.cours.table.rows.push(dataRow)
    //       state.detail.cours.table.total = state.detail.cours.table.rows.length
    //     }
    //   }
    // },
    [types.SET_HRMS75E_ADD_CODCOURS] (state, dataRows) {
      for (var row = 1; row <= dataRows.length; row++) {
        let dataRow = dataRows[row - 1]
        let duplicateDataRow = state.detail.cours.table.rows.filter(function (stateDataRow) {
          return stateDataRow.codcours === dataRow.codcours
        })
        if (duplicateDataRow.length === 0) {
          dataRow['flgAdd'] = true
          state.detail.cours.table.rows.push(dataRow)
          state.detail.cours.table.total = state.detail.cours.table.rows.length
        }
      }
    },
    [types.SET_HRMS75E_INDEX_ADD_INLINE] (state, obj) {
      let data = obj.data
      let param = obj.param
      let rowIndex = state.index.rows.map(function (dataRow) {
        return dataRow.codempid
      }).indexOf(param.codempid)
      state.index.rows[rowIndex] = {
        desc_codempid: data.desc_codempid,
        desc_codpos: data.desc_codpos,
        codcours: data.codcours,
        desc_codcours: data.desc_codcours,
        desc_codtparg: data.desc_codtparg,
        v_flgqlify: data.v_flgqlify
      }
    }
  },
  actions: {
    [types.TOGGLE_HRMS75E_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRMS75E_INDEX_DISP, indexDisp)
      commit(types.SET_HRMS75E_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRMS75E_INDEX_ADD_INLINE] ({ commit }, param) {
      hrms75e.getIndexAddInline(param.codempid)
        .then((response) => {
          const codempidData = JSON.parse(response.request.response)
          commit(types.SET_HRMS75E_INDEX_ADD_INLINE, { data: codempidData, param: param })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS75E_COLUMNS_LABELS] ({ commit }) {
      axios.all([
        hrms75e.getLabels(),
        hrms75e.getDropdowns()
      ])
      .then(axios.spread(function (responseLabels, responseDropdowns) {
        const dataDropdowns = JSON.parse(responseDropdowns.request.response)
        commit(types.SET_HRMS75E_DROPDOWNS, dataDropdowns)
        const dataLabels = JSON.parse(responseLabels.request.response)
        commit(types.SET_HRMS75E_COLUMNS, { labels: dataLabels.labels, dropdowns: dataDropdowns })
        commit(types.SET_HRMS75E_LABELS, dataLabels.labels)
      }))
      .catch((error) => {
        let message = error
        if (error.response) {
          const data = error.response.data
          message = data.response
        }
        swal({
          title: '', text: message, html: true, type: 'error'
        }, function () {
          window.onkeydown = null; window.onfocus = null; swal('')
        })
      })
    },
    [types.RECEIVED_HRMS75E_INDEX] ({ commit }, searchParams) {
      hrms75e.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS75E_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          let result = {
            total: 0,
            rows: []
          }
          commit(types.SET_HRMS75E_INDEX, result)
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS75E_DETAIL_CREATE] ({ commit }) {
      hrms75e.getDetailCreate()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS75E_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS75E_DETAIL] ({ commit, dispatch }, searchParams) {
      hrms75e.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS75E_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          dispatch(types.RECEIVED_HRMS75E_DETAIL_CREATE)
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS75E_DETAIL_TAB2_POPUP] ({ commit }, popupParams) {
      hrms75e.getDetailTab2Popup(popupParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS75E_DETAIL_TAB2_POPUP, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS75E_DETAIL_TAB4_POPUP] ({ commit }, popupParams) {
      hrms75e.getDetailTab4Popup(popupParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS75E_DETAIL_TAB4_POPUP, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS75E_COURS_POPUP] ({ commit }, popupParams) {
      hrms75e.getPopupCours(popupParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS75E_COURS_POPUP, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRMS75E_TAB1_SAVE] ({ commit, dispatch }, saveParams) {
      swal({
        title: 'confirmTitle',
        text: 'msgConfirmSave',
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: 'ok',
        cancelButtonText: 'cancel',
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms75e.postSave(saveParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS75E_INDEX, {})
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS75E_TAB4_SAVE] ({ commit, dispatch }, saveParams) {
      swal({
        title: 'confirmTitle',
        text: 'msgConfirmSave',
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: 'ok',
        cancelButtonText: 'cancel',
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms75e.postSave(saveParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS75E_INDEX, {})
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS75E_DETAIL_COURS_SAVE] ({ commit, dispatch }, { dataRowsHasFlg, searchIndex, searchDetailCours }) {
      swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
      hrms75e.postDetailCoursSave({ dataRowsHasFlg, searchDetailCours })
        .then((response) => {
          const data = JSON.parse(response.request.response)
          dispatch(types.RECEIVED_HRMS75E_INDEX, searchIndex)
          dispatch(types.RECEIVED_HRMS75E_DETAIL, searchDetailCours)
          swal({
            title: '', text: data.response, html: true, type: 'success'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRMS75E_INDEX_CANCEL] ({ commit, dispatch }, { dataRowsHasFlg, searchIndex }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmCancel'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: 'ok',
        cancelButtonText: 'cancel',
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms75e.postIndexCancel({ dataRowsHasFlg, searchIndex })
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS75E_INDEX, searchIndex)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hrms75e/index.js